<template>
  <AppHeader>Customer Milk Summary</AppHeader>

  <FromToDate @filter="getData"></FromToDate>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table" v-if="data.length != 0">
      <table>
        <thead>
          <tr>
            <th>Customer</th>
            <th>Deliveries</th>
            <th v-for="(quantity, product) in total['products']" :key="product">{{ product }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Total</b></td>
            <td><b>{{ total.totalDeliveries }}</b></td>
            <td v-for="(quantity, product) in total['products']" :key="product"><b>{{ quantity }}</b></td>
          </tr>
          <tr v-for="customer in data" :key="customer.customer.id">
            <td><b><router-link :to="{name: 'ViewCustomer', params: {id: customer.customer.id}}">{{ customer.customer.name }} <small>(#{{ customer.customer.id }})</small></router-link></b></td>
            <td>{{ customer.totalDeliveries }}</td>
            <td v-for="(quantity, product) in total['products']" :key="product"><b>{{ customer.products[product] || 0 }}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="m-2">
        <button class="px-2 py-1 mr-1 text-white rounded-full bg-slate-500" @click="downloadExcel">Excel</button>
      </div>
    </div>

    <div class="text-center text-gray-500" v-else>
      <p>Please select From & To date to filter</p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import FromToDate from '@/components/common/FromToDate.vue';

export default {
  name: 'ReportCustomerSummary',
  mixins: [ mixin ],
  components: { AppHeader, Loading, FromToDate },
  data() {
    return {
      state: 'idle',
      data: [],
      total: {},
      form: {},
    }
  },

  methods: {
    downloadExcel() {
      this.openDownloadUrl('utils/reports/customerMilkSummary/' + btoa(this.$store.state.user.id + ':' + this.form.from + ':' + this.form.to));
    },

    getData(from, to) {
      this.state = 'loading';
      this.form.from = from;
      this.form.to = to;

      this.request('GET', 'reports/customer-summary?from=' + from + '&to=' + to, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) this.calculateTotal(resp.data);
        else alert(resp.message);
      });
    },

    calculateTotal(data) {
      let total = {totalDeliveries: 0, products: {}};

      data.forEach((cust) => {
        total['totalDeliveries'] += cust['totalDeliveries'];
        for (const [product, quantity] of Object.entries(cust['products'])) {
          if (!total['products'][product]) {
            total['products'][product] = 0;
          }
          total['products'][product] += quantity;
        }
      });

      data.sort((a, b) => a.customer.name.localeCompare(b.customer.name));
      this.data = data;
      this.total = total;
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
